module.exports = __webpack_public_path__ + "static/media/toolbar_opentool.f59318d6.png";